import React from 'react'
import moment from 'moment'
import ReactTable from 'react-table'
import {
  Button,
  Form,
  Modal,
  Popconfirm,
  Input,
  Icon,
  Radio,
  AutoComplete,
  Tooltip,
  Spin,
  Upload,
  Select
} from 'antd'
import MaterialRequestItems from '../../../components/MaterialRequestItems'
import { filterCaseInsensitive, convertToOption, convertToReactSelectOption } from '../../../util'
import config from '../../../config'
import styled from 'styled-components'

const FilesUploadContainer = styled.div`
  padding: 10px;
  margin: 10px 0;
  border-radius: 4px;
  border: 1px solid #e2e2e2;
  -webkit-box-shadow: 0px 0px 35px -12px rgba(204, 204, 204, 1);
  -moz-box-shadow: 0px 0px 35px -12px rgba(204, 204, 204, 1);
  box-shadow: 0px 0px 35px -12px rgba(204, 204, 204, 1);
`

const EditAttachmentContainer = styled.div`
  padding: 10px;
  margin: 10px 0;
  border-radius: 4px;
  border: 1px solid #e2e2e2;
  background-color: #eeeeee;
`
const EditAttachmentTitle = styled.h6`
  color: #fff;
`
const EditingFileContainer = styled.div`
  margin: 10px 0;
`

const { API_BASE } = config
const FormItem = Form.Item
const { TextArea } = Input
const RadioButton = Radio.Button
const RadioGroup = Radio.Group
const Option = Select.Option

const JobSiteMaterialRequestModal = ({
  contentData,
  loadingRevision,
  currentRevisionNumberPrint,
  uploadProps,
  getFieldDecorator,
  revisions,
  handleSelectedTemplate,
  handleCancel,
  handleCreate,
  materialRequestTemplatesActions,
  handleTemplateChange,
  handleRevisionChange,
  attachmentDetailsVisible,
  confirmDelete,
  cancelDelete,
  attachmentName,
  attachmentDescription,
  onDescriptionChange,
  handleUpdateAttachmentDescription,
  confirmAttachmentDelete,
  currentId,
  handleAttachmentRowClick,
  uploadAttachment,
  allItems,
  getMaterialRequestTemplateName,
  getAllItems,
  jobSiteMaterialRequestActions,
  requestItems,
  deleteItem,
  moveUp,
  moveDown,
  addItem,
  saveRequestItems,
  onItemChange
}) => (
  <Modal
    visible
    title="Material Request"
    width={1020}
    okText={contentData ? 'Save Changes' : 'Create'}
    onCancel={handleCancel}
    onOk={handleCreate}
    maskClosable={false}
  >
    <Form layout="vertical">
      <div className="row">
        <div className="col-md-12">
          <FormItem label="Template">
            {getFieldDecorator('material_request_template_id', {
              initialValue:
                contentData && getMaterialRequestTemplateName
                  ? getMaterialRequestTemplateName(contentData.material_request_template_id)
                  : ''
            })(
              <AutoComplete
                dataSource={convertToOption(
                  materialRequestTemplatesActions &&
                    materialRequestTemplatesActions.materialRequestTemplates &&
                    materialRequestTemplatesActions.materialRequestTemplates.data
                )}
                filterOption={(inputValue, option) =>
                  option.props.children.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                }
                onChange={handleTemplateChange}
              >
                <Input suffix={<Icon type="search" className="certain-category-icon" />} />
              </AutoComplete>
            )}
          </FormItem>
        </div>
      </div>
      <div className="row">
        <div className="col-md-6">
          <FormItem label="Requested By">
            {getFieldDecorator('requested_by', {
              rules: [
                {
                  required: true,
                  message: 'Requested by cannot be blank.'
                }
              ],
              initialValue: contentData ? contentData.requested_by : ''
            })(<Input placeholder="Requested by..." />)}
          </FormItem>
        </div>
        <div className="col-md-3">
          {contentData && (
            <FormItem label="Revision">
              {getFieldDecorator('revision', {
                initialValue:
                  revisions && revisions.length > 0 ? revisions[revisions.length - 1].id : null
              })(
                loadingRevision ? (
                  <Spin size="small" />
                ) : (
                  <Select onChange={handleRevisionChange}>
                    {revisions &&
                      revisions.map(revision => (
                        <Option key={revision.id} value={revision.id}>
                          {revision.revision}
                        </Option>
                      ))}
                  </Select>
                )
              )}
            </FormItem>
          )}
        </div>

        {contentData &&
          contentData.scheduledDeliveryInfo && (
            <div className="col-md-3">
              <div className="jobDetailsHeader">Schedule Delivery</div>
              <FormItem>
                <label> {`Vehicle: ${contentData.scheduledDeliveryInfo.vehicle_name}`}</label>
              </FormItem>
              <FormItem>
                <label>{`Driver: ${contentData.scheduledDeliveryInfo.driver_first_name} ${
                  contentData.scheduledDeliveryInfo.driver_last_name
                }`}</label>
              </FormItem>
              <FormItem>
                <label>{`Scheduled Date: ${moment(
                  contentData.scheduledDeliveryInfo.scheduled_date
                ).format('YYYY-MM-DD')}`}</label>
              </FormItem>
            </div>
          )}

        <div className="col-md-6 text-right">
          {contentData && (
            <div className="row">
              <div className="col-md-11">
                <FormItem label="Status">
                  {getFieldDecorator('completed', {
                    initialValue: contentData ? contentData.completed : ''
                  })(
                    <RadioGroup>
                      <RadioButton value={0}>Created</RadioButton>
                      <RadioButton value={1}>Completed</RadioButton>
                    </RadioGroup>
                  )}
                </FormItem>
              </div>
              <div className="col-md-1">
                <a
                  href={`${API_BASE}/api/job/job_site_material_requests/print/${
                    contentData.id
                  }?revision=${currentRevisionNumberPrint}`}
                  target="_blank"
                >
                  <Button icon="printer" className="marginRight10" />
                </a>
              </div>
            </div>
          )}
        </div>
      </div>
      <FormItem label="Description">
        {getFieldDecorator('description', {
          initialValue: contentData ? contentData.description : ''
        })(
          <TextArea
            placeholder="Type in description..."
            rows={4}
            initialvalue={contentData ? contentData.description : ''}
          />
        )}
      </FormItem>
      <MaterialRequestItems
        getAllItems={getAllItems}
        templateManagement={false}
        allItems={allItems && convertToReactSelectOption(allItems)}
        requestItems={requestItems}
        deleteItem={deleteItem}
        moveUp={moveUp}
        moveDown={moveDown}
        addItem={addItem}
        saveRequestItems={saveRequestItems}
        onItemChange={onItemChange}
      />
      {contentData && (
        <FilesUploadContainer>
          <div className="row">
            <div className="col-md-6">
              <h5>
                <Icon type="check" /> Material Request Files
              </h5>
            </div>
            <div className="col-md-6 text-right">
              {jobSiteMaterialRequestActions &&
                jobSiteMaterialRequestActions.uploadingAttachment && (
                  <div className="text-success">
                    <Icon type="loading" /> Uploading File(s)
                  </div>
                )}
              {jobSiteMaterialRequestActions &&
                jobSiteMaterialRequestActions.deletingAttachment && (
                  <div className="text-danger">
                    <Icon type="loading" /> Deleting File(s)
                  </div>
                )}
            </div>
          </div>
          {jobSiteMaterialRequestActions &&
            jobSiteMaterialRequestActions.jobMaterialRequestsAttachments &&
            jobSiteMaterialRequestActions.jobMaterialRequestsAttachments.data.length > 0 && (
              <Spin spinning={jobSiteMaterialRequestActions.loadingAttachments}>
                <ReactTable
                  defaultPageSize={5}
                  data={jobSiteMaterialRequestActions.jobMaterialRequestsAttachments.data}
                  getTrProps={(state, rowInfo, column, instance) => ({
                    onClick: e => handleAttachmentRowClick(rowInfo.original)
                  })}
                  defaultFilterMethod={filterCaseInsensitive}
                  columns={[
                    {
                      Header: 'Attached Files',
                      columns: [
                        {
                          Header: 'Filename',
                          id: 'filename',
                          accessor: 'filename',
                          Cell: d => (
                            <Tooltip title={d.original.filename}>{d.original.filename}</Tooltip>
                          )
                        },
                        {
                          Header: 'Description',
                          id: 'description',
                          accessor: 'description',
                          Cell: d => (
                            <Tooltip title={d.original.description}>
                              {d.original.description}
                            </Tooltip>
                          )
                        },
                        {
                          Cell: row => (
                            <Tooltip placement="left" title="Open this file on a new window">
                              <a target="_blank" href={row.original.signedUrl}>
                                <Icon type="export" className="fontSize20" />
                              </a>
                            </Tooltip>
                          ),
                          maxWidth: 35
                        }
                      ]
                    }
                  ]}
                  defaultSorted={[
                    {
                      id: 'id',
                      desc: true
                    }
                  ]}
                  className="-striped -highlight"
                />
              </Spin>
            )}
          {attachmentDetailsVisible && (
            <EditAttachmentContainer>
              <EditAttachmentTitle>
                <Icon type="edit" /> Edit Attachment Area
              </EditAttachmentTitle>
              <div>
                <EditingFileContainer>
                  <Icon type="file" /> {attachmentName}
                </EditingFileContainer>
              </div>
              <div className="row">
                <div className="col-md-10">
                  <TextArea
                    placeholder="Describe the attachment..."
                    rows={4}
                    onChange={onDescriptionChange}
                    value={attachmentDescription}
                  />
                </div>
              </div>
              <div className="d-flex flex-row mt-2">
                <Button onClick={handleUpdateAttachmentDescription}>
                  <Icon type="save" /> OK
                </Button>{' '}
                <Popconfirm
                  title="Are you sure you want to delete this attachment?"
                  onConfirm={confirmAttachmentDelete}
                  okText="Yes"
                  cancelText="No"
                >
                  <Button type="danger" icon="delete" className="ml-2">
                    {' '}
                    DELETE
                  </Button>
                </Popconfirm>
              </div>
            </EditAttachmentContainer>
          )}
          <br />
          <div>Upload Material Request File(s)</div>
          <br />
          <Upload {...uploadProps} name="file" customRequest={uploadAttachment}>
            <Button>
              <Icon type="upload" /> Upload
            </Button>
          </Upload>
        </FilesUploadContainer>
      )}
      <Popconfirm
        title="Are you sure you want to delete this record?"
        onConfirm={confirmDelete}
        onCancel={cancelDelete}
        okText="Yes"
        cancelText="No"
      >
        {contentData && <Button type="danger" icon="delete" />}
      </Popconfirm>
    </Form>
  </Modal>
)

export default JobSiteMaterialRequestModal



// WEBPACK FOOTER //
// ./src/containers/job/tasks/JobSiteMaterialRequestModal.js